import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { gql } from '@apollo/client';
export var CLAIMS_MUTATION = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    mutation claims($input: ClaimsInput) {\n        claims(input: $input)\n    }\n"])));